import type { ModelState } from '@/features/domaine/types/techniques'

export const $estDirty = '$estDirty'
export type DirtyState = { $estDirty?: boolean }

export type Dirty<T extends object> = ModelState<T, DirtyState>
